import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import * as styles from './style.module.css';
import { useCustomerContext } from '../../../contexts/CustomerContext';

export default function LoggedInIndicator() {
    const { customer } = useCustomerContext();

    if (!customer.token) return null;

    return (
        <div slot="about" className={styles.indicator} title="Store logged in">
            <FontAwesomeIcon icon={faCircle} size="2xs" />
        </div>
    );
}
